import React from 'react';
import AccessDenied from './AccessDenied';
import {usePermissions} from '../../utils/usePermissions';

/**
 * PermissionGuard wrapper to protect routes in the frontend.
 * 
 * @param {string} module - The module name (e.g., 'stock', 'clients')
 * @param {string} action - The action required (default: 'read')
 * @param {React.ReactNode} children - The component to render if access is granted
 */
const PermissionGuard = ({module, action = 'read', children, onNavigate, onLogout, currentPage}) => {
    const {hasPermission} = usePermissions();

    if (!hasPermission(module, action)) {
        return <AccessDenied module={module} onNavigate={onNavigate} onLogout={onLogout} currentPage={currentPage} />;
    }

    return <>{children}</>;
};

export default PermissionGuard;
